module.exports = __webpack_public_path__ + "static/compete2030-d2622d5f8330f08763b9be357f36d757.png";